import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react component for creating beautiful carousel
import Carousel from 'react-slick';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// @material-ui/icons
import Share from '@material-ui/icons/Share';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
// core components
import Header from 'components/Header/Header.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';

import headersStyle from 'assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.jsx';

import bg12 from 'assets/img/bg12.jpg';
import office2 from 'assets/img/examples/office2.jpg';

import dg3 from 'assets/img/events/dg3.jpg';
import dg4 from 'assets/img/events/dg4.jpg';
import dg5 from 'assets/img/events/dg5.jpg';
import dg6 from 'assets/img/events/dg6.jpg';
import dg7 from 'assets/img/events/dg7.jpg';
import dg8 from 'assets/img/events/dg8.jpg';
import dg9 from 'assets/img/events/dg9.jpg';
import dg10 from 'assets/img/events/dg10.jpg';

function SectionHeaders({ ...props }) {
  const { classes, ...rest } = props;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };
  return (
    // we've set the className to cd-section so we can make smooth scroll to it
    <div className="cd-section" {...rest}>
      <div>
        <Carousel {...settings}>
          {/* Carousel 3 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ height: '900px', backgroundImage: `url("${dg3}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={7}
                    md={7}
                    className={classNames(classes.mlAuto, classes.textRight)}
                  >
                    <h1 className={classes.title}>
                      Awareness and intuition awaking.
                    </h1>
                    <h3 style={{ color: 'white' }}>
                      Every answer is inside. Trust yourself, open your inner
                      teacher.
                    </h3>
                    <h5 style={{ color: 'white' }}>
                      This is a powerful practice for Ajna chakra. Ajna chakra
                      is third-eye chakra or Guru chakra. It connected people to
                      their intuition. Supposedly, Ajna is a part of the brain
                      which can be made more powerful through meditation yoga
                      and other spiritual practices just as a muscle is. The
                      practice is built with special series of asanas,
                      vinyasanas, and pranayamas for activating Ajna center. It
                      purificates your mind, destroys non-positive thoughts, and
                      removes blocks. It is a powerful step to your awaking, it
                      brings new “light” in your life, the light of new vision
                      of reality. The practice includes Moon Salutation and
                      meditation.
                    </h5>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 3 END */}

          {/* Carousel 1 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ height: '900px', backgroundImage: `url("${dg4}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6}>
                    <h3 style={{ color: 'white' }} className={classes.title}>
                      I let love in. I give love.
                    </h3>
                    <h4 style={{ color: 'white' }}>
                      The most important thing in life is to learn how to give
                      out love, and to let it come in.
                    </h4>
                    <h5 style={{ color: 'white' }}>
                      It is Universal Mandala Yoga Event of static-dynamic
                      sequence for Anahata chakra. It includes specially built
                      sequences of asanas, vinyasas, pranayamas (breathing
                      exercises), and visualization for Anahata chakra opening.
                      The Anahata chakra, or heart chakra, is the fourth chakra
                      and locates at the center of the seven chakras with three
                      below and three above. The Anahata associated with
                      unconditional love, compassion, and joy. It is the source
                      of deep and profound truths that cannot be expressed in
                      words. Anahata is a bridge between the lower and upper
                      chakras integrating the physical with the spiritual. The
                      Sanskrit word “Anahata” means “unstruck” or “unhurt.” The
                      name implies that beneath the hurts and grievances of past
                      experiences lies a pure and spiritual place where no hurt
                      exists. A closed heart chakra gives way to grief, anger,
                      jealousy, fear of betrayal, and hatred toward yourself and
                      others. When your heart chakra is open, you are flowing
                      with love and compassion, you are quick to forgive, and
                      you accept others and yourself
                    </h5>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 1 END */}
          {/* Carousel 2 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ height: '900px', backgroundImage: `url("${dg5}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={8}
                    md={8}
                    className={classNames(
                      classes.mlAuto,
                      classes.mrAuto,
                      classes.textCenter,
                    )}
                  >
                    <h1 className={classes.title}>
                      Allow cosmic energies to flow through your body.
                    </h1>
                    <h3 style={{ color: 'white' }}>
                      Chakras are doorways into other dimensions, focus on them.
                    </h3>
                    <h4>
                      According to Hindu and Buddhist tradition chakras are vast
                      (yet confined) pools of energy in our bodies which govern
                      our psychological qualities. This practice cleans Sushumna
                      (central energy channel), aura and chakras. During the
                      practice we do sequences of asanas for every chakra from
                      lower to upper ones with relevant bija mantras (sound
                      vibrations) and visualizations of color and energy flow.
                      We finish with meditation to fill all chakras with energy
                      and activate it. This technique helps you to get a lot of
                      positive energy.
                    </h4>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 2 END */}
          {/* Carousel 3 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ height: '900px', backgroundImage: `url("${dg6}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={7}
                    md={7}
                    className={classNames(classes.mlAuto, classes.textRight)}
                  >
                    <h1 className={classes.title}>Open your inner teacher</h1>
                    <h3 style={{ color: 'white' }}>
                      The true path is not a straight line, it a spiral.
                    </h3>
                    <h4>
                      This is a Mandala practice with space rotations. The
                      practice forms energy spiral based on reduction of number
                      of asanas with every rotation. It leads to the special
                      state that opens your clear mind and your inherent inner
                      wisdom, your inner teacher and power. First part of the
                      practice devoted to purification and the second part
                      devoted to gathering and activation of energy. The
                      practice includes Japa mantra
                    </h4>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 3 END */}

          {/* Carousel 1 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ height: '900px', backgroundImage: `url("${dg7}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6}>
                    <h1 className={classes.title}>
                      Awakening to the treasure within
                    </h1>
                    <h3 style={{ color: 'white' }}>
                      This is the path one travels into and through and the
                      final result is a saint.
                    </h3>
                    <h4>
                      Kundalini is a form of divine energy located at the base
                      of the spine. This energy when cultivated and awaken
                      through practice leads to spiritual liberation. It is a
                      deep practice leading you to yourself to understand your
                      real desires, emotions, thoughts and feelings. There are a
                      variety of methods for Kundalini awakings. We use a
                      powerful tantric method with bandhas (locks), breathe
                      delays, asanas, and energy flow. The practice includes
                      meditation with singing bowl. Kundalini practice is the
                      way to your sacred freedom
                    </h4>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 1 END */}
          {/* Carousel 2 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ height: '900px', backgroundImage: `url("${dg8}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={8}
                    md={8}
                    className={classNames(
                      classes.mlAuto,
                      classes.mrAuto,
                      classes.textCenter,
                    )}
                  >
                    <h2 style={{ color: 'white' }} className={classes.title}>
                      Let your wishes come true
                    </h2>
                    <h3 style={{ color: 'white' }}>
                      Give life for your wishes.
                    </h3>
                    <h5 style={{ color: 'white' }}>
                      Unique ceremony based on Buddhist tradition with mantras
                      and ritual attributes to make your wishes true and get rid
                      of anything undesirable. The practice consists of series
                      of asanas developed in a particular sequence, with turns
                      in space that have extensive energetic meaning, pranayamas
                      (breathing practices), vinyasas (specific sequences of
                      breath- synchronized movements used to transition between
                      sustained postures). During the practice you will be
                      offered asanas and pranayamas of different difficulty
                      levels, making it doable for everyone. All participants
                      will be a part of unified Mandala (geometrical symbol of a
                      complex structure that is interpreted as a model of the
                      universe and includes all its elements: earth, air, water,
                      fire, ether). It is a good chance to put more energy to
                      materialize your plans and destroy blocks and barriers.
                      The practice can be performed in special days only.
                    </h5>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 2 END */}
          {/* Carousel 3 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ height: '900px', backgroundImage: `url("${dg9}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={7}
                    md={7}
                    className={classNames(classes.mlAuto, classes.textRight)}
                  >
                    <h1 className={classes.title}>Yoga is Light</h1>
                    <h3 style={{ color: 'white' }}>
                      Turn your face toward the Sun and shadows fall behind you.
                    </h3>
                    <h4>
                      Sun Salutation or Surya Namaskar is a sequence of asanas.
                      It strengthens and lights the entire body. Your body is
                      the key to your inner world. We use this key to reach the
                      center of your awareness at some point in your body (such
                      as third eye, your heart, etc.) through concentration
                      during Surya Namaskar practice. It challenges you to keep
                      focusing inside during the practice for all of its
                      duration. During the lesson we use various techniques to
                      keep your focusing inside. Full practice consists of three
                      lessons with repeating Sun Salutation sequence 36 times
                      (in total it will be 108 times) with relevant mantras and
                      visualization for every position. It’s powerful method to
                      clean your mental plan and open your inner power.
                    </h4>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 3 END */}

          {/* Carousel 3 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ height: '900px', backgroundImage: `url("${dg10}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={7}
                    md={7}
                    className={classNames(classes.mlAuto, classes.textRight)}
                  >
                    <h1 className={classes.title}>
                      Energy gathering and balance.
                    </h1>
                    <h3 style={{ color: 'white' }}>
                      Even in the most unbalanced situations the balance is
                      never too far.
                    </h3>
                    <h4>
                      This is a powerful original practice from Guru Lama Lappa
                      “Sama Vrtti Vyannayama”. Guru Lama Lappa is the world
                      famous modern teacher, creator and founder of Mandala
                      Yoga. The practice includes static-dynamic sequences of
                      asanas, pranayamas, visualizations and mantras for
                      bringing balance for your mental and physical planes by
                      working with all shells of your aura on various layers.
                      Greetings and gathering of energy from all sides of the
                      world for your development are creating during the
                      practice.
                    </h4>
                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 3 END */}
        </Carousel>
      </div>
      {/* HEADER 3 END */}
    </div>
  );
}

export default withStyles(headersStyle)(SectionHeaders);



// WEBPACK FOOTER //
// ./src/views/YogaPage/EventCarousel.jsx